import { useState, useEffect } from 'react';

import { ThemeProvider, createTheme } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import Loader from 'shared/containers/Loader';
import { RefreshTokenT } from 'shared/models/auth';
import accessToken from 'utils/accessToken';
import api from 'utils/api';
import authToken from 'utils/authToken';
import { useAuth } from 'utils/hooks/providers/auth-context';
import { EntityNameForNavProvider } from 'utils/hooks/providers/entity-name-for-nav-context';

import './App.scss';

import AppRouter from './containers/AppRouter';

function App() {
  const MATERIAL_UI_THEME = createTheme({
    typography: {
      fontFamily: 'Montserrat, sans-serif',
      fontSize: 25.6,
    },
    palette: {
      primary: {
        main: '#052267',
      },
      secondary: {
        main: '#EB1E58',
      },
      warning: {
        main: '#FDC830',
      },
    },
  });

  const [isGlobalLoading, setIsGlobalLoading] = useState(true);
  const [isBackendDown, setIsBackendDown] = useState(false);

  const { setAuthState } = useAuth();

  const handleToken = (token: string) => {
    const tokenExtractedData = authToken.extractData(token);
    accessToken.set(token);
    setAuthState({
      ...tokenExtractedData,
    });
  };

  useEffect(() => {
    api.auth.refreshTokens()
      .then((resp: Response) => {
        if (resp.status >= 400) {
          setIsGlobalLoading(false);
        } else {
          resp.json()
            .then((data: RefreshTokenT) => {
              handleToken(data.access_token);
              setIsGlobalLoading(false);
            });
        }
      })
      .catch(() => setIsBackendDown(true));
  }, []);

  return (
    <EntityNameForNavProvider>
      <ThemeProvider theme={MATERIAL_UI_THEME}>
        <div>
          {
            isGlobalLoading
              ? (
                <div className="root--loader">
                  <Loader.Section disableShrink />
                  {
                    isBackendDown
                      ? <h2>Server connection failed</h2>
                      : null
                  }
                </div>
              )
              : (
                <>
                  <AppRouter />
                  <ToastContainer position="bottom-right" />
                </>
              )
          }
        </div>
      </ThemeProvider>
    </EntityNameForNavProvider>
  );
}

export default App;
